export function getSegmentedTabsTrackSx(isFullWidth, trackBg, trackRadiusPx, minHeight = 34) {
  return {
    width: isFullWidth ? '100%' : 'max-content',
    minHeight,
    p: '3px',
    borderRadius: `${trackRadiusPx}px`,
    bgcolor: trackBg,
    boxSizing: 'border-box',
    flexShrink: isFullWidth ? 1 : 0,
    minWidth: isFullWidth ? 0 : undefined,
    overflow: isFullWidth ? 'visible' : 'hidden',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    '& .MuiTabs-flexContainer': {
      gap: '2px',
      flexWrap: 'nowrap',
      ...(isFullWidth ? { width: '100%', minWidth: 'min-content' } : {}),
    },
    ...(isFullWidth
      ? {
          '& .MuiTab-root': {
            flex: '1 1 auto',
            flexShrink: 0,
            width: 'auto',
            minWidth: 'min-content',
            maxWidth: 'none',
            overflow: 'visible',
          },
          '& .MuiTab-root.Mui-selected': {
            width: 'auto',
            minWidth: 'min-content',
          },
          '& .MuiTab-root .MuiTab-label': {
            overflow: 'visible',
            textOverflow: 'clip',
          },
        }
      : {}),
    '& .MuiTabs-scroller': {
      overflow: 'visible !important',
    },
  }
}
